import {Component, Input, OnInit} from '@angular/core';
import {Snake} from './snake';

@Component({
  selector: 'app-snake',
  templateUrl: './snake.component.html',
  styleUrls: ['./snake.component.css']
})
export class SnakeComponent implements OnInit {
  @Input() snake: Snake;
  @Input() bitSize = 10;

  ngOnInit(): void {
  }
}
